import { fetchApi } from '@/config/axiosSetting';
import { AddSubstitutionPartParams } from '@/modules/adjusterReportModules/IncidentParticipants/queries/addSubstitutionPart/addSubstitutionPartQuery.type';

export const AddSubstitutionPartQueryFunction = (
  params: AddSubstitutionPartParams,
) => {
  return fetchApi.post(
    `property/reports/${params?.id}/accident_users/damaged/adjusting/substitution_parts/`,
    params?.data,
    {
      params: {
        damaged_id: params?.damaged_id,
        source: params?.source,
        id: params?.id,
      },
    },
  );
};
